/* NAIVROX bundle prompt — sets the product quantity from a tier button */
if (!customElements.get('nvx-bundle')) {
  customElements.define(
    'nvx-bundle',
    class NvxBundle extends HTMLElement {
      connectedCallback() {
        this.tiers = this.querySelectorAll('[data-qty]');
        this.qtyInput =
          document.querySelector('.product-form__quantity input[name="quantity"]') ||
          document.querySelector('input[name="quantity"]');

        this.tiers.forEach((btn) => {
          btn.addEventListener('click', () => {
            const qty = parseInt(btn.dataset.qty, 10) || 1;
            this.tiers.forEach((b) => b.classList.toggle('is-selected', b === btn));
            if (this.qtyInput) {
              this.qtyInput.value = qty;
              this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }
    }
  );
}
